module.exports = __webpack_public_path__ + "images/stickers/taco-trophy.77785938bb3566b20d1e.png";